export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RichVerticalIndicator.vue?vue&type=template&id=0dfc0aba&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-wizard/indicators/RichVerticalIndicator.vue?vue&type=template&id=0dfc0aba&scoped=true
// module id = 4UPF
// module chunks = 41